module.exports = __webpack_public_path__ + "img/2019.20799538.jpg";